import moment from "moment";
const isOneMinuteOld = (dateValue) =>
  moment.utc().diff(moment.utc(dateValue), "minutes") >= 1;

// convert 01011999 into 01/01/1999 as the user types
const formatDateInput = (value) => {
  // Remove everything except digits
  const digits = value.replace(/\D/g, "").slice(0, 8);

  let formatted = "";

  if (digits.length > 0) {
    formatted += digits.substring(0, 2);
  }

  if (digits.length > 2) {
    formatted += "-" + digits.substring(2, 4);
  }

  if (digits.length > 4) {
    formatted += "-" + digits.substring(4, 8);
  }

  return formatted;
};

export { isOneMinuteOld, formatDateInput };
